import Address from '../models/Address';

type AddressComponent =
  'street_number' |
  'route' |
  'sublocality_level_1' |
  'locality' |
  'administrative_area_level_1' |
  'country' |
  'postal_code';

class AddressService {
  public convertToAddress(result: google.maps.places.PlaceResult): Address {
    const components = result?.address_components;
    if (!components) {
      return null;
    }
    const streetNumber = this.getComponent(components, 'street_number');
    const route = this.getComponent(components, 'route');
    const suburb = this.getComponent(components, 'sublocality_level_1');
    const city = this.getComponent(components, 'locality');
    const region = this.getComponent(components, 'administrative_area_level_1');
    const country = this.getComponent(components, 'country');
    const postcode = this.getComponent(components, 'postal_code');

    return {
      street: `${streetNumber} ${route}`,
      suburb,
      city,
      region,
      country,
      postcode
    } as Address;
  }

  private getComponent(
    components: google.maps.GeocoderAddressComponent[],
    type: AddressComponent
  ) {
    return components.find(c => !!c.types?.find(t => t == type))?.long_name || '';
  }
}

export default new AddressService();
